import { push as pushRoute } from 'connected-react-router';

import {
    put, all, select, takeLatest,
} from 'redux-saga/effects';

import {
    buildQueryParameters,
    extractQueryParameters,
} from 'helpers/RoutesHelpers';
import { getLocationSelector } from '../../commons/selectors/RouterSelector';

import {
    CLOSE_CMP_MODAL,
    reloadPage,
} from '../reduxModules/ConsentManagementPlatform';

export function* callAction() {
    const location = yield select(getLocationSelector);
    const searchParameters = extractQueryParameters(location.search);
    delete searchParameters['cmp-modal'];
    location.search = buildQueryParameters(searchParameters);
    yield all([
        put(pushRoute(location)),
        put(reloadPage()),
    ]);
}

export function* watch() {
    yield takeLatest(CLOSE_CMP_MODAL, callAction);
}
